export default __webpack_public_path__ + "static/media/h03.09daa595.svg";